// eslint-disable-next-line import/prefer-default-export
export const WaitingTimeTypes = Object.freeze({
  SHORT: 'SHORT',
  LONG: 'LONG',
  CUSTOM: 'CUSTOM',
});
